import { Module } from 'vuex-smart-module';
import NotificationsActions from './actions';
import NotificationsGetters from './getters';
import NotificationsMutations from './mutations';
import NotificationsState from './state';

export default new Module({
  state: NotificationsState,
  mutations: NotificationsMutations,
  actions: NotificationsActions,
  getters: NotificationsGetters,
});
